<template>
<UModal @update:open="isOpen = $event" :title="$t('Write a review')">
     <slot />
    <template #body="{ close }">
        <div v-if="pending">
            {{ $t('Loading...') }}
        </div>
        <UAlert v-else-if="error" color="error" class="mb-4">
            {{ error }}
        </UAlert>
        <ProductReviewForm v-else :productId="props.productId" @cancel="close" :review="review" @review="handleReview($event, close)" />
    </template>
</UModal>
</template>
<script setup lang="ts">
const { t: $t } = useI18n()

import type { ProductReview } from '~/types';
import ProductReviewForm from './ProductReviewForm.vue';

const props = defineProps<{
  productId: number;
  reviewId?: number;
}>();

const catalogService = useCatalogService();

const pending = ref(!!props.reviewId);
const error = ref<string | null>(null);

const review = ref<ProductReview>();

const isOpen = ref(false);

watch(isOpen, async (newVal) => {
  if (newVal && props.reviewId && !review.value) {
    try {
      pending.value = true;
      const reviewData = await catalogService.getReview(props.reviewId);
      review.value = reviewData;
    } catch (e) {
      error.value = $t('Failed to load review.');
    } finally {
      pending.value = false;
    }
  }
}, { immediate: true });

const emit = defineEmits<{
  (e: 'review:update', review: ProductReview): void;
  (e: 'review:create', review: ProductReview): void;
}>();

const handleReview = (review : ProductReview, close : Function) => {
  if (props.reviewId) {
    emit('review:update', review);
  } else {
    emit('review:create', review);
  }

  close();
};
</script>